export default {
  w: 448,
  p: 'M335.664 227.429V456h-37.333V227.429h-74.666v-57.143H410.33v57.143h-74.666ZM186.332 113.143V456h-37.333V113.143H37V56h279.998v57.143H186.332Z',
}
